module.exports = __webpack_public_path__ + "img/menu-banner-community.76514a0e.png";